import * as React from 'react';

function SvgSignAgreement(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#sign-agreement_svg__a)">
        <path fill="#fff" d="M0 0h24v24H0z" />
        <path d="M4 4.5h12V6h4v17H6v-4.5H4v-14z" fill="#FCCE01" />
        <path
          d="M19.204 9.903a2.772 2.772 0 113.92 3.92l-3.773 3.774-3.92-3.92 3.773-3.774z"
          fill="#FCCE01"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 1.15A1.85 1.85 0 001.15 3v15A1.85 1.85 0 003 19.85h2.15V22A1.85 1.85 0 007 23.85h12A1.85 1.85 0 0020.85 22v-3.5a.85.85 0 00-1.7 0V22a.15.15 0 01-.15.15H7a.15.15 0 01-.15-.15V7A.15.15 0 017 6.85h12a.15.15 0 01.15.15v1.5a.85.85 0 001.7 0V7A1.85 1.85 0 0019 5.15h-2.15V3A1.85 1.85 0 0015 1.15H3zm12.15 4V3a.15.15 0 00-.15-.15H3a.15.15 0 00-.15.15v15c0 .083.067.15.15.15h2.15V7A1.85 1.85 0 017 5.15h8.15zm-5.15 5c0-.47.38-.85.85-.85h4.3a.85.85 0 010 1.7h-4.3a.85.85 0 01-.85-.85zm-.65 3.15a.85.85 0 000 1.7h3.3a.85.85 0 000-1.7h-3.3zm-.85 5.35c0-.47.38-.85.85-.85h.8a.85.85 0 010 1.7h-.8a.85.85 0 01-.85-.85zm13.804-7.766a1.25 1.25 0 00-1.767 0l-.884.884 1.767 1.767.884-.884a1.25 1.25 0 000-1.767zm-4.065 2.298l-4.95 4.95 1.768 1.767 4.95-4.95-1.768-1.767zM15.056 19.9l-1.986.459a.2.2 0 01-.24-.24l.459-1.986 1.767 1.767z"
          fill="#595959"
        />
      </g>
      <defs>
        <clipPath id="sign-agreement_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgSignAgreement;
